import React from 'react'
import './portal.css'
import { Modal } from 'react-bootstrap'

const Portal = (props) => {

    const handleClose = () => props.setShow(false)

    return (
        <>
            <Modal show={props.show} onHide={handleClose} animation={false} centered>
                <Modal.Body>
                    <div className='portal'>
                        <div className="portal__edicion">

                            <section className="section__cabecera">
                                <p>{props.terminos.titulo}</p>
                            </section>

                            <section className="section__cuerpo">
                                {
                                    props.terminos.descrip.map((des,i) => {
                                        return <p key ={i} >{des}</p>
                                    })
                                }
                            </section>

                            <section className="section__btn">
                                <div className='section__btnItem' onClick={handleClose}>Aceptar</div>
                            </section>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Portal